var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{class:{'modal': true, 'is-active': _vm.show}},[_c('div',{staticClass:"modal-background"}),_c('div',{staticClass:"modal-content has-text-centered"},[_c('div',{staticClass:"loader-box my-6"},[_c('div',{staticClass:"loader"})])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }